import './Main.css'

import React from 'react'

import { useWizard } from '@/common/wizard/wizard'
import { useAppContext } from '@/context/app'
import { useChecklistSubmit, WizardData } from './Model'
import { goToAddFailurePage, StartAddFailurePage } from '@/pages/communal/machine/failures/add/Main'
import { Machine } from '@/services/model/machine'
import { MachineName } from '@/components/machine'
import { useNavigate } from 'react-router-dom'

export interface SimpleUserGroup {
  id: string
  name: string
}

const stepId = 'seat_sensor'

export const SeatSensorStep = ({ machine }: {
  machine: Machine
}) => {
  const { services, session, translates } = useAppContext()
  const navigate = useNavigate()
  const submitChecklist = useChecklistSubmit(machine.id)
  const { wizardData, updateWizardData, nextStep } = useWizard<WizardData>()

  if (translates === undefined || wizardData === undefined) {
    return <div className='spinner'></div>
  }

  return <div>
    <h3>{translates.for('machine.checklist.wizard.seat_sensor.title')}</h3>
    <p className='desc'>
      {translates.for('machine.checklist.wizard.seat_sensor.description')}
    </p>

    <div className='btns'>
      <a className='btn btn-next main-btn' onClick={() => {
        updateWizardData({ acceptedSteps: [...wizardData.acceptedSteps, stepId] })
        nextStep()
      }}>
        {translates.for('machine.checklist.wizard.seat_sensor.approve')}
      </a>
      <a className='btn btn-fail main-red-btn' onClick={async () => {
        if (!await submitChecklist('fail', stepId)) return
        goToAddFailurePage({
          navigate,
          machineId: machine.id
        })
      }}>
        {translates.for('machine.checklist.wizard.seat_sensor.fail')}
      </a>
    </div>

  </div>
}
